module.exports = __webpack_public_path__ + "c02d358d7f21da9c13248c143f6452ab.svg";